'use client';

import { Toaster as Sonner, type ToasterProps, toast } from 'sonner';
import { CheckCircle, Info, SpinnerGap, Warning, WarningCircle, X } from '../icons';

/**
 * Toasts, themed to our tokens and Phosphor icons. Positioned top-centre on a
 * phone so a toast never covers the bottom tab bar or a sticky CTA.
 */
function Toaster(props: ToasterProps) {
  return (
    <Sonner
      position="top-center"
      offset={16}
      duration={5000}
      icons={{
        success: <CheckCircle size={20} weight="fill" />,
        info: <Info size={20} weight="fill" />,
        warning: <Warning size={20} weight="fill" />,
        error: <WarningCircle size={20} weight="fill" />,
        loading: <SpinnerGap size={20} className="animate-spin" />,
        close: <X size={16} />,
      }}
      toastOptions={{
        classNames: {
          toast:
            'group flex w-full items-start gap-3 rounded-(--radius-card) border border-border bg-surface p-4 text-body text-navy-900 shadow-(--shadow-raised) font-sans',
          title: 'font-semibold',
          description: 'text-meta text-neutral-600',
          actionButton:
            'rounded-(--radius-pill) bg-gold-400 px-3 py-1.5 text-meta font-semibold text-navy-900',
          cancelButton:
            'rounded-(--radius-input) bg-navy-100 px-3 py-1.5 text-meta font-medium text-navy-900',
          success: 'text-success-700',
          error: 'text-danger-700',
          warning: 'text-warning-700',
          info: 'text-info-700',
        },
      }}
      {...props}
    />
  );
}

export { Toaster, toast };
